export default __webpack_public_path__ + "static/media/loadDataInProgress.52d8cdce.svg";